<script setup lang="ts">
import {RefreshCcw04} from "utruckin-icons";
import CommonButton from "@/components/common/CommonButton.vue";
import {useRouter} from "vue-router";

const router = useRouter();

const goBack = () => {
  router.go(-1);
}

const goHome = () => {
  router.push("/");
}
</script>

<template>
  <div class="v-error">
    <div class="main">
      <div class="main__content">
        Error
      </div>

      <div class="main__headline">
        Something went wrong
      </div>

      <div class="main__description">
        An unexpected error occurred. Please try again later or contact support if the problem persists.
      </div>

      <div class="main__action">
        <CommonButton @click="goBack" type="outline" prepend :prepend-icon="RefreshCcw04"
                      label="Refresh"></CommonButton>
        <CommonButton @click="goHome" type="primary" label="Go to home"/>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>